// 天干
export const STEMS = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸']

// 地支
export const BRANCHES = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥']

// 基本宮
export const PALACES = [
  '命宮',
  '父母',
  '福德',
  '田宅',
  '官祿',
  '僕役',
  '遷移',
  '疾厄',
  '財帛',
  '子女',
  '夫妻',
  '兄弟',
  '身宮'
]

// 五行
export const WU_XINGS = [
  { name: '金四局', value: 4 },
  { name: '水二局', value: 2 },
  { name: '火六局', value: 6 },
  { name: '土五局', value: 5 },
  { name: '木三局', value: 3 }
]

// 十四主星
export const MAIN_STARS = [
  '紫微',
  '天機',
  '太陽',
  '武曲',
  '天同',
  '廉貞',
  '天府',
  '太陰',
  '貪狼',
  '巨門',
  '天相',
  '天梁',
  '七殺',
  '破軍'
]

export const STEM_YEAR_APPLYS = [
  ['MAIN5', 'MAIN13', 'MAIN3', 'MAIN2'], ['MAIN1', 'MAIN11', 'MAIN0', 'MAIN7'], ['MAIN4', 'MAIN1', 'AUX3', 'MAIN5'],
  ['MAIN7', 'MAIN4', 'MAIN1', 'MAIN9'], ['MAIN8', 'MAIN7', 'AUX6', 'MAIN1'], ['MAIN3', 'MAIN8', 'MAIN11', 'AUX4'],
  ['MAIN2', 'MAIN3', 'MAIN7', 'MAIN4'], ['MAIN9', 'MAIN2', 'AUX4', 'AUX3'], ['MAIN11', 'MAIN0', 'AUX5', 'MAIN3'],
  ['MAIN13', 'MAIN9', 'MAIN7', 'MAIN8']
]
export const EMPEROR_STARS_OFFSET = [0, 1, 2, 1, 1, 3]
export const TREASURY_STARS_OFFSET = [0, 1, 1, 1, 1, 1, 1, 4]

export const STARS_BRIGHTNESS = {
  MAIN0: [1, 3, 2, 2, 1, 2, 3, 3, 2, 2, 1, 2], // 紫微 EMPEROR
  MAIN1: [3, 0, 1, 2, 1, 1, 3, 0, 1, 2, 1, 1], // 天機 MERCY
  MAIN2: [0, 0, 2, 3, 2, 2, 2, 1, 1, 1, 0, 0], // 太陽 SUN
  MAIN3: [2, 3, 1, 1, 3, 1, 2, 3, 1, 1, 3, 1], // 武曲 FINANCE
  MAIN4: [2, 0, 1, 1, 1, 3, 0, 0, 2, 1, 1, 3], // 天同 LUCKY
  MAIN5: [1, 1, 3, 1, 1, 0, 1, 1, 3, 1, 1, 0], // 廉貞 WICKED,
  MAIN6: [3, 3, 3, 1, 3, 1, 2, 3, 1, 2, 3, 1], // 天府 TREASURY
  MAIN7: [3, 3, 2, 0, 0, 0, 0, 0, 1, 2, 2, 3], // 太陰 MOON
  MAIN8: [2, 3, 1, 1, 3, 0, 2, 3, 1, 1, 3, 0], // 貪狼 FLIRTING
  MAIN9: [2, 0, 3, 3, 0, 2, 2, 0, 3, 3, 0, 2], // 巨門 GLOOMY
  MAIN10: [3, 3, 3, 0, 1, 1, 3, 1, 3, 0, 1, 1], // 天相 MINISTER
  MAIN11: [3, 2, 3, 3, 3, 0, 3, 2, 0, 1, 3, 0], // 天梁 BLESSING
  MAIN12: [2, 3, 3, 2, 3, 1, 2, 3, 3, 2, 3, 1], // 七殺 POWER
  MAIN13: [3, 2, 1, 0, 2, 1, 3, 2, 1, 0, 2, 1], // 破軍 RUINOUS
  AUX3: [1, 3, 0, 1, 1, 3, 0, 1, 1, 3, 0, 1], // 文昌 LITERATURE
  AUX4: [1, 3, 1, 2, 1, 3, 0, 2, 1, 3, 0, 2], // 文曲 ELOQUENCE
  AUX8: [0, 3, -1, 0, 3, -1, 0, 3, -1, 0, 3, -1], // 擎羊 TROUBLESOME
  AUX9: [-1, 3, 0, -1, 3, 0, -1, 3, 0, -1, 3, 0], // 陀羅 WORRISOME
  AUX10: [0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1], // 火星 TURMOIL
  AUX11: [0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1], // 鈴星 TURBULENCE
}

// 月系星
export const MONTHLY_STARS = [
  '左輔',
  '右弼',
  '天馬',
  '天刑',
  '天姚',
  '解神',
  '陰煞',
  '天巫',
  '天月'
]
export const MONTHLY_STARS_OFFSET = [
  4,
  10,
  8,
  9,
  1,
  8,
  2,
  [5, 8, 2, 11],
  [10, 5, 4, 2, 7, 3, 11, 7, 2, 6, 10, 2]
]

// 日系星
export const DAILY_STARS = ['三台', '八貴', '恩光', '天貴']

// 時系星
export const HOURLY_STARS = [
  { name: '文昌', offset: 10 },
  { name: '文曲', offset: 4 },
  { name: '火星', offset: [2, 3, 1, 9] },
  { name: '鈴星', offset: [10, 10, 3, 10] },
  { name: '地劫', offset: 11 },
  { name: '地空', offset: 11 },
  { name: '台輔' },
  { name: '封誥' },
]

// 年干星
export const YEAR_STEM_STARS = [
  '祿存',
  '天魁',
  '天銊',
  '擎羊',
  '陀羅',
  '天官',
  '天褔',
  '天廚',
  '截空'
]

export const YEAR_STEM_STARS_RULE = [
  [2, 1, 7, 7, 9, 5, 8],
  [3, 0, 8, 4, 8, 6, 6],
  [5, 11, 9, 5, 0, 0, 4],
  [6, 11, 9, 2, 11, 5, 2],
  [5, 1, 7, 3, 3, 6, 0],
  [6, 0, 8, 9, 2, 8, 9],
  [8, 1, 7, 11, 6, 2, 7],
  [9, 6, 2, 9, 5, 6, 5],
  [11, 3, 5, 10, 6, 9, 3],
  [0, 3, 5, 6, 5, 11, 1]
]

// 年支星
export const YEAR_BRANCH_STARS = [
  { name: '紅鸞', offset: 3 },
  { name: '天喜' },
  { name: '天空' },
  { name: '天哭', offset: 6 },
  { name: '天虚', offset: 6 },
  { name: '龍池', offset: 4 },
  { name: '鳳閣', offset: 10 },
  { name: '孤辰', offset: [2, 5, 8, 11] },
  { name: '寡宿', offset: [10, 1, 4, 7] },
  { name: '蜚廉', offset: [8, 9, 10, 5, 6, 7, 2, 3, 4, 11, 0, 1] },
  { name: '破碎', offset: [5, 1, 9] },
  // { name: '咸池', offset: [9, 6, 3, 0] },
  // { name: '華蓋', offset: [4, 1, 10, 7] },
  // { name: '龍德', offset: 7 },
  { name: '月德', offset: 5 },
  // { name: '劫煞', offset: [5, 2, 11, 8] },
  // { name: '年解', offset: 10 },
  // { name: '天德', offset: 9 },
  { name: '天才' },
  { name: '天壽' }
]

// 其他星
export const OTHER_STARS = ['旬空', '天傷', '天使']

// 四化星
export const APPLY_STARS = ['祿', '權', '科', '忌']

// 太歲十二神 大耗=歲破
export const YEAR12_STARS = [
  '太歲',
  '晦氣',
  '喪門',
  '貫索',
  '官符',
  '小耗',
  '大耗',
  '龍德',
  '白虎',
  '天德',
  '吊客',
  '病符'
]

// 將前十二神
export const GENERAL12_STARS_OFFSET = [0, 9, 6, 3]
export const GENERAL12_STARS = [
  '將星',
  '攀鞍',
  '歲驛',
  '息神',
  '華蓋',
  '劫煞',
  '災煞',
  '天煞',
  '指背',
  '咸池',
  '月煞',
  '亡神'
]

// 博士十二神
export const DOCTOR12_STARS = [
  '博士',
  '力士',
  '青龍',
  '小耗',
  '將軍',
  '奏書',
  '飛廉',
  '喜神',
  '病符',
  '大耗',
  '伏兵',
  '官符',
]

// 長生十二神
export const LONGLIFE12_STARS_OFFSET = [5, 8, 2, 8, 11]
export const LONGLIFE12_STARS = [
  '長生',
  '沐浴',
  '冠帶',
  '臨官',
  '帝旺',
  '衰',
  '病',
  '死',
  '墓',
  '絕',
  '胎',
  '養'
]

// 命主身主
export const SELF_LORD = [
  MAIN_STARS[8],
  MAIN_STARS[9],
  YEAR_STEM_STARS[0],
  HOURLY_STARS[0].name,
  MAIN_STARS[5],
  MAIN_STARS[3],
  MAIN_STARS[13],
]
export const LIFE_LORD = [
  HOURLY_STARS[2].name,
  MAIN_STARS[10],
  MAIN_STARS[11],
  MAIN_STARS[4],
  HOURLY_STARS[1].name,
  MAIN_STARS[1],
]

/* Reference */
// Aux Stars
export const AUX_STARS = [
  '祿存',
  '天魁',
  '天鉞',
  '文昌',
  '文曲',
  '左輔',
  '右弼',
  '天馬',
  '擎羊',
  '陀羅',
  '火星',
  '鈴星',
  '地空',
  '地劫'
]

// Ziwei Sexes
export const YINGYANG = ['陰女', '陰男', '陽女', '陽男']

export const ASTROLABE_VERSION = {
  PREVIEW: 0,
  SIMPLE: 1,
  FULL: 2,
}
